var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage = function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Image_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "Image_svg__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.937 8.68-.01-.028a.997.997 0 0 0-.22-.359l-5.999-6a.997.997 0 0 0-.646-.28c-.01 0-.02-.004-.029-.007A.115.115 0 0 0 13 2H6c-1.103 0-2 .897-2 2v16c0 1.103.897 2 2 2h12c1.103 0 2-.897 2-2V9a.115.115 0 0 0-.006-.033.145.145 0 0 1-.007-.029.99.99 0 0 0-.05-.258zM13 4v5h5l-5-5zm-3 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zM9 16l1 1 3-4 5 7H6l3-4z",
    fill: "#606060"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#Image_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E3451",
    d: "M0 0h24v24H0z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgImage;